'use strict';

export default function ManageGroupService($http, $cookies, $state) {
  'ngInject';

  let ManageGroup = {
    getUsers () {
      return $http.get('/api/users')
        .then(response => {
          console.log('The Users list fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log('The User list fetch unsuccessful');
          throw err;
        });
    },
    getPatients () {
      return $http.get('/api/patients/list')
        .then(response => {
          console.log('The Patients list fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log('The Patients list fetch unsuccessful');
          throw err;
        });
    },
    getGroups() {
      return $http.get('/api/groups')
        .then(response => {
          console.log('The Groups fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log('Either the Manager is not registered with the group or manager does not exist');
          throw err;
        });
    },
    renameGroup(data) {
      return $http.put('/api/groups/' + data._id, {
        name: data.name
      })
        .then((response) => {
          console.log('The group has been renamed successfully');
          return response.data;
        })
        .catch(err => {
          console.log('Cannot rename the group');
          throw err;
        })
    },
    createGroup(data) {
      return $http.post('/api/groups', {name: data})
        .then((response) => {
          console.log('The group has been created successfully');
          return response.data;
        })
        .catch(err => {
          console.log(err);     //view the error here
          console.log('Cannot create the group');
          throw err;
        })
    },
    mergeGroup(data) {
      return $http.post('/api/groups/merge', {mergeFrom: data.mergeFrom, mergeTo: data.mergeTo})
        .then((response) => {
          console.log('The group has been merged successfully');
          return response.data;
        })
        .catch(err => {
          throw err.data;
        })
    },
  getPhysicians() {
      return $http.get('/api/groups/staffMembers')
        .then(response => {
          console.log(response.data)
          console.log('The Physician list has been fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log(err);
          console.log('The physician list fetch unsuccessful');
          throw err;
        })
    },
    getQuestion(id) {
      return $http.get('api/groupQuestions/'+ id +'/all')
        .then((response) => {
          console.log('Question data fetched successfully');
          return response;
        })
        .catch(err => {
          console.log(err);     //view the error here
          console.log('Question data not fetched');
          throw err;
        })
    }
  }
  return ManageGroup;
}




// WEBPACK FOOTER //
// ./client/app/admin/manager/manager.service.js